var map = {
	"./Levels": 5844,
	"./Levels.json": 5844,
	"./LevelsStaking": 8909,
	"./LevelsStaking-6": 2042,
	"./LevelsStaking-6.json": 2042,
	"./LevelsStaking.abi": 3548,
	"./LevelsStaking.json": 8909,
	"./Metafluence": 4236,
	"./Metafluence.json": 4236,
	"./MetafluenceV2.sol": 6015,
	"./Meto_Contract.sol": 3794,
	"./Meto_Token.sol": 6431,
	"./ProdSuperPool": 4363,
	"./ProdSuperPool.json": 4363,
	"./Staking": 8592,
	"./Staking-23": 6316,
	"./Staking-23.json": 6316,
	"./Staking-old": 4344,
	"./Staking-old.json": 4344,
	"./Staking.json": 8592,
	"./Staking.sol": 7371,
	"./StakingM6": 4003,
	"./StakingM6.json": 4003,
	"./Staking_12": 294,
	"./Staking_12.json": 294,
	"./Staking_3": 8726,
	"./Staking_3.json": 8726,
	"./Staking_6": 2725,
	"./Staking_6.json": 2725,
	"./Staking_9": 8364,
	"./Staking_9.json": 8364,
	"./SuperPool": 4608,
	"./SuperPool.json": 4608,
	"./abi": 9579,
	"./abi.json": 9579,
	"./erc20abi": 3195,
	"./erc20abi.json": 3195
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9132;